import React, { Component } from 'react';
import { toString, replace, find, get, map, indexOf } from 'lodash';
import validator from 'validator';
import { connect } from 'react-redux';

import AddressCard from './AddressCard';
import AddressSelect from './AddressSelect';

class AddressForm extends Component {
  state = {
    selectedAddress: null
  };

  gtmSubject = this.props.showPickup ? 'Pickup' : 'Receiver';

  handleTextInputChange = (value, name) => {
    this.setState({
      [name]: value
    });
  };

  handleTextInputBlur = name => {
    if (this.gtmEvents[name]) {
      window.dataLayer.push({
        event: this.gtmEvents[name],
        ecommerce: undefined
      }); // move to blur event to prevent fire while inputting
    }

    this.setState({
      [name + 'Status']: this.validateError(name) ? 'error' : '',
      [name + 'Help']: this.validateError(name)
    });
  };

  handleInputChange = (value, name) => {
    this.setState(
      {
        [name]: value,
        [name + 'Changed']: true
      },
      () => {
        this.setState({
          [name + 'Status']: this.validateError(name) ? 'error' : '',
          [name + 'Help']: this.validateError(name)
        });
      }
    );
  };

  handleInputBlur = name => {
    this.setState(
      {
        [name + 'Changed']: true
      },
      () => {
        this.setState({
          [name + 'Status']: this.validateError(name) ? 'error' : '',
          [name + 'Help']: this.validateError(name)
        });
      }
    );
  };

  handleRegionChange = value => {
    this.setState({
      region: value,
      area: '',
      areaChanged: undefined
    });
  };

  validate = () => {
    let success = true;

    if (this.addressCard.current && !this.addressCard.current.validate()) {
      success = false;
    }

    return success;
  };

  validateError = name => {
    let patterns;
    const value = toString(this.state[name]);

    if (value.length > 35) {
      return '請輸入少於35個字符';
    }

    switch (this.validateType[name]) {
      case 'optional':
        patterns = /^[0-9A-Z\s\-.,/'"():;$&@!?]+$/i;

        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return null;
        }

        if (!patterns.test(value)) {
          return `pickup.err_msg.${name}.format`;
        }
        return null;
      case 'required':
        patterns = /^[0-9A-Z\s\-.,/'"():;$&@!?]+$/i;

        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return `pickup.err_msg.${name}.empty`;
        }
        if (!patterns.test(value)) {
          return `pickup.err_msg.${name}.format`;
        }
        return null;
      case 'phone':
        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return `pickup.err_msg.${name}.empty`;
        }
        if (!validator.isMobilePhone(replace(value, /\s/g, ''))) {
          return `pickup.err_msg.${name}.format`;
        }

        return null;
      case 'chars':
        patterns = /^[A-Z\s\-.']+$/i;

        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return `pickup.err_msg.${name}.empty`;
        }
        if (!patterns.test(value)) {
          return `pickup.err_msg.${name}.format`;
        }
        return null;
      case 'zip': // TODO: match country
        patterns = /^[0-9A-Z\s\-']+$/i;

        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return `pickup.err_msg.${name}.empty`;
        }
        if (!patterns.test(value)) {
          return `pickup.err_msg.${name}.format`;
        }
        return null;
      default:
        return null;
    }
  };

  getFormData = bypass => {
    let addressData = {};

    if (this.addressCard.current) {
      addressData = this.addressCard.current.getFormData();
    } else {
      const selectedAddress = this.state.selectedAddress;
      addressData = {
        ...(selectedAddress
          ? find(this.props.addresses, ['ref', selectedAddress])
          : this.props.addresses[0])
      };

      if (!addressData.type) {
        addressData.type = this.state[`${selectedAddress}_type`];
        addressData.toUpdate = true;
      }

      if (!bypass) {
        if (!addressData.type) {
          this.setState({
            [`${selectedAddress}_help`]: 'pickup.err_msg.type.empty',
            [`${selectedAddress}_validateStatus`]: 'error'
          });
        }
      }
    }

    return {
      ...addressData
    };
  };

  handleAddressClick = ref => {
    this.setState(
      {
        selectedAddress: ref
      },
      this.autoSave
    );
  };

  addressCard = React.createRef();

  addAddress = () => {
    this.setState(
      {
        selectedAddress: 'new'
      },
      () => {
        window.scrollTo(0, this.container.current.offsetTop - 53);
      }
    );
  };

  container = React.createRef();

  componentDidMount() {
    const refList = map(this.props.addresses, 'ref');
    let selectedAddress;

    if (
      this.props.recoverAddress.ref &&
      indexOf(refList, this.props.recoverAddress.ref) !== -1
    ) {
      selectedAddress = this.props.recoverAddress.ref;
    } else {
      selectedAddress = get(this.props.addresses, '[0].ref');
    }

    this.setState({
      selectedAddress
    });
  }

  autoSave = () => {
    const key = this.props.showPickup ? 'fromAddress' : 'toAddress';
    const data = this.getFormData(true);
    data.country = this.props.country;

    this.props.autoSave(key, data);
  };

  handlePickerOpen = open => {
    if (open) {
      setTimeout(() => {
        const input = document.querySelector('.ant-picker-input input');
        input.readOnly = true; // to prevent keyboard popup
      }, 0);
    }
  };

  updateType = type => {
    const { selectedAddress } = this.state;
    this.setState({
      [`${selectedAddress}_type`]: type,
      [`${selectedAddress}_help`]: '',
      [`${selectedAddress}_validateStatus`]: ''
    });
  };

  render() {
    return (
      <div ref={this.container}>
        {(() => {
          const { addresses, recoverAddress } = this.props;

          if (addresses.length && this.state.selectedAddress !== 'new') {
            return (
              <>
                <AddressSelect
                  t={this.props.t}
                  handleAddressClick={this.handleAddressClick}
                  type={this.state[`${this.state.selectedAddress}_type`]}
                  help={this.state[`${this.state.selectedAddress}_help`]}
                  validateStatus={
                    this.state[`${this.state.selectedAddress}_validateStatus`]
                  }
                  updateType={this.updateType}
                  addresses={addresses}
                  selectedAddress={this.state.selectedAddress}
                  addAddress={this.addAddress}
                  fromAddress={this.props.showPickup}
                />
              </>
            );
          }

          return (
            <AddressCard
              t={this.props.t}
              ref={this.addressCard}
              carrier={this.props.carrier}
              country={this.props.country}
              fromAddress={this.props.showPickup}
              recoverAddress={recoverAddress}
              autoSave={this.autoSave}
              showPickup={this.props.showPickup}
              showPostOfficeBoxHint={this.props.showPostOfficeBoxHint}
            />
          );
        })()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    getAutoSaveFinished: !!state.shipments.getAutoSaveFinished
  };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(
  AddressForm
);
